module.exports = __webpack_public_path__ + "static/media/requisition.53fef7ec.svg";